import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../../../config/supabase';
import { apiUrl } from '../../../config/supabase';

// قراءة اللوجات/الجلسات من السيرفر (الجداول مقفولة عن الجمهور)
const empToken = () => { try { return localStorage.getItem('emp_token') || ''; } catch { return ''; } };
const fetchLogs = async (kind) => {
  try {
    const res = await fetch(apiUrl('/api/admin/logs'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: empToken(), kind }),
    });
    const r = await res.json().catch(() => ({}));
    return (res.ok && r.ok && Array.isArray(r.rows)) ? r.rows : [];
  } catch { return []; }
};

// ── ألوان ثابتة ────────────────────────────────────────────
const C = {
  primary:  '#5a67d8',
  purple:   '#764ba2',
  green:    '#16a34a',
  red:      '#dc2626',
  amber:    '#d97706',
  cyan:     '#0891b2',
  text:     '#1f2937',
  muted:    '#6b7280',
  border:   '#e5e7eb',
  bg:       '#f9fafb',
  white:    '#ffffff',
  success:  '#dcfce7',
  successT: '#16a34a',
  danger:   '#fee2e2',
  dangerT:  '#dc2626',
  pending:  '#fef3c7',
  pendingT: '#d97706',
};

// ── مساعدات ────────────────────────────────────────────────
const fmt = (n) => Number(n || 0).toLocaleString('ar-EG');
const fmtDate = (d) => d ? new Date(d).toLocaleString('ar-EG', { year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit' }) : '—';
const fmtDateOnly = (d) => d ? new Date(d).toLocaleDateString('ar-EG') : '—';
const today = () => new Date().toISOString().split('T')[0];
const monthAgo = () => { const d = new Date(); d.setMonth(d.getMonth()-1); return d.toISOString().split('T')[0]; };

// ── مكون: حقل الفلتر ──────────────────────────────────────
const FilterField = ({ label, children }) => (
  <div style={{ display:'flex', flexDirection:'column', gap:'4px', minWidth:'140px' }}>
    <label style={{ fontSize:'11px', fontWeight:'500', color:C.muted, textTransform:'uppercase', letterSpacing:'0.05em' }}>{label}</label>
    {children}
  </div>
);

const Input = ({ ...p }) => (
  <input {...p} style={{ padding:'7px 10px', border:`1px solid ${C.border}`, borderRadius:'8px', fontSize:'13px', color:C.text, background:C.white, outline:'none', width:'100%', boxSizing:'border-box', ...p.style }} />
);

const Select = ({ children, ...p }) => (
  <select {...p} style={{ padding:'7px 10px', border:`1px solid ${C.border}`, borderRadius:'8px', fontSize:'13px', color:C.text, background:C.white, outline:'none', width:'100%', boxSizing:'border-box', ...p.style }}>
    {children}
  </select>
);

// ── مكون: بطاقة إحصاء ─────────────────────────────────────
const StatCard = ({ label, value, color, sub }) => (
  <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:'12px', padding:'16px', flex:1, minWidth:'130px' }}>
    <p style={{ margin:0, fontSize:'12px', color:C.muted, fontWeight:'500' }}>{label}</p>
    <p style={{ margin:'6px 0 0', fontSize:'22px', fontWeight:'bold', color: color||C.primary }}>{value}</p>
    {sub && <p style={{ margin:'2px 0 0', fontSize:'11px', color:C.muted }}>{sub}</p>}
  </div>
);

// ── مكون: جدول ────────────────────────────────────────────
const Table = ({ cols, rows, emptyMsg = 'لا توجد بيانات' }) => {
  const [page, setPage] = useState(1);
  const PER = 20;
  const total = rows.length;
  const pages = Math.ceil(total / PER);
  const slice = rows.slice((page-1)*PER, page*PER);

  return (
    <div>
      <div style={{ overflowX:'auto', borderRadius:'10px', border:`1px solid ${C.border}` }}>
        <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'13px', minWidth:'500px' }}>
          <thead>
            <tr style={{ background:C.bg }}>
              {cols.map((c,i) => (
                <th key={i} style={{ padding:'10px 14px', textAlign:'right', fontWeight:'600', color:C.text, borderBottom:`1px solid ${C.border}`, whiteSpace:'nowrap', fontSize:'12px' }}>
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {slice.length === 0 ? (
              <tr><td colSpan={cols.length} style={{ padding:'32px', textAlign:'center', color:C.muted }}>{emptyMsg}</td></tr>
            ) : slice.map((row, ri) => (
              <tr key={ri} style={{ borderBottom:`1px solid ${C.bg}`, background: ri%2===0 ? C.white : C.bg }}>
                {cols.map((c,ci) => (
                  <td key={ci} style={{ padding:'10px 14px', color: c.color||C.text, fontWeight: c.bold?'600':'400', whiteSpace: c.nowrap?'nowrap':'normal' }}>
                    {c.render ? c.render(row) : (row[c.key] ?? '—')}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {pages > 1 && (
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:'12px', fontSize:'12px', color:C.muted }}>
          <span>إجمالي: {total} سجل</span>
          <div style={{ display:'flex', gap:'6px' }}>
            {Array.from({length:Math.min(pages,7)},(_,i)=>i+1).map(p => (
              <button key={p} onClick={()=>setPage(p)}
                style={{ width:'28px', height:'28px', border:`1px solid ${p===page?C.primary:C.border}`, borderRadius:'6px', background: p===page?C.primary:C.white, color: p===page?C.white:C.text, cursor:'pointer', fontSize:'12px', fontWeight:p===page?'600':'400' }}>
                {p}
              </button>
            ))}
            {pages>7 && <span>...</span>}
          </div>
          <span>صفحة {page} من {pages}</span>
        </div>
      )}
    </div>
  );
};

// ── بارشارت بسيط ─────────────────────────────────────────
const BarChart = ({ data, height=140, label='', valueKey='v', labelKey='l', color=C.primary }) => {
  const max = Math.max(...data.map(d=>d[valueKey]), 1);
  return (
    <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:'12px', padding:'16px' }}>
      {label && <p style={{ margin:'0 0 12px', fontSize:'13px', fontWeight:'600', color:C.text }}>{label}</p>}
      <div style={{ display:'flex', alignItems:'flex-end', gap:'8px', height:`${height}px` }}>
        {data.map((d,i) => (
          <div key={i} style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', gap:'4px', height:'100%', justifyContent:'flex-end' }}>
            {d[valueKey]>0 && <span style={{ fontSize:'10px', color:C.primary, fontWeight:'600' }}>{fmt(d[valueKey])}</span>}
            <div style={{ width:'100%', borderRadius:'4px 4px 0 0', background: i===data.length-1?color:`${color}66`, height:`${Math.max((d[valueKey]/max)*100,d[valueKey]>0?6:2)}%`, transition:'height 0.4s', minHeight:'2px' }} />
            <span style={{ fontSize:'10px', color:C.muted, whiteSpace:'nowrap', overflow:'hidden', maxWidth:'100%', textOverflow:'ellipsis' }}>{d[labelKey]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

// ══════════════════════════════════════════════════════════
// ① تقرير الإيرادات
// ══════════════════════════════════════════════════════════
function RevenueReport({ payments, courses }) {
  const [from,     setFrom]     = useState(monthAgo());
  const [to,       setTo]       = useState(today());
  const [method,   setMethod]   = useState('');
  const [status,   setStatus]   = useState('');
  const [courseId, setCourseId] = useState('');
  const [search,   setSearch]   = useState('');

  const filtered = payments.filter(p => {
    const d = new Date(p.paid_at || p.created_at);
    if (from && d < new Date(from)) return false;
    if (to   && d > new Date(to + 'T23:59:59')) return false;
    if (method   && p.method   !== method)   return false;
    if (status   && p.status   !== status)   return false;
    if (courseId && String(p.course_id) !== courseId) return false;
    if (search) {
      const s = search.toLowerCase();
      const cname = courses.find(c=>c.id===p.course_id)?.name_ar||'';
      if (!cname.toLowerCase().includes(s) && !(p.receipt_note||'').toLowerCase().includes(s)) return false;
    }
    return true;
  });

  const active = filtered.filter(p=>p.status==='active'||p.status==='approved');
  const totalRev = active.reduce((s,p)=>s+(p.amount||0),0);

  // مخطط شهري
  const monthly = Array.from({length:6},(_,i)=>{
    const d=new Date(); d.setMonth(d.getMonth()-(5-i));
    return {
      l: d.toLocaleDateString('ar-EG',{month:'short'}),
      v: payments.filter(p=>{
        const pd=new Date(p.paid_at||p.created_at);
        return pd.getMonth()===d.getMonth()&&pd.getFullYear()===d.getFullYear()&&(p.status==='active'||p.status==='approved');
      }).reduce((s,p)=>s+(p.amount||0),0)
    };
  });

  const cols = [
    { key:'#',     label:'#',            nowrap:true, render:(_,i)=>i+1 },
    { key:'date',  label:'التاريخ',      nowrap:true, render:r=>fmtDate(r.paid_at||r.created_at) },
    { key:'course',label:'الكورس',       render:r=>courses.find(c=>c.id===r.course_id)?.name_ar||'—' },
    { key:'method',label:'طريقة الدفع',  nowrap:true, render:r=>r.method==='card'?'💳 كارت':r.method==='vodafone'?'📱 فودافون':'🏦 تحويل' },
    { key:'coupon',label:'كوبون',        render:r=>r.receipt_note?.includes('كوبون:')?r.receipt_note.split('كوبون:')[1]?.trim()||'—':'—' },
    { key:'amount',label:'المبلغ',       bold:true, color:C.green, render:r=>`${fmt(r.amount)} جنيه` },
    { key:'status',label:'الحالة',       render:r=>{
      const s=r.status; const isActive=s==='active'||s==='approved';
      const isPending=s==='pending';
      return <span style={{padding:'2px 8px',borderRadius:'6px',fontSize:'11px',fontWeight:'600',background:isActive?C.success:isPending?C.pending:C.danger,color:isActive?C.successT:isPending?C.pendingT:C.dangerT}}>
        {isActive?'مكتمل':isPending?'معلق':'مرفوض'}
      </span>;
    }},
  ];

  return (
    <div style={{display:'flex',flexDirection:'column',gap:'16px'}}>
      {/* فلاتر */}
      <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:'12px',padding:'16px',display:'flex',flexWrap:'wrap',gap:'12px',alignItems:'flex-end'}}>
        <FilterField label="من تاريخ"><Input type="date" value={from} onChange={e=>setFrom(e.target.value)} /></FilterField>
        <FilterField label="إلى تاريخ"><Input type="date" value={to} onChange={e=>setTo(e.target.value)} /></FilterField>
        <FilterField label="طريقة الدفع">
          <Select value={method} onChange={e=>setMethod(e.target.value)}>
            <option value="">الكل</option>
            <option value="card">كارت</option>
            <option value="vodafone">فودافون كاش</option>
            <option value="transfer">تحويل</option>
          </Select>
        </FilterField>
        <FilterField label="الحالة">
          <Select value={status} onChange={e=>setStatus(e.target.value)}>
            <option value="">الكل</option>
            <option value="active">مكتمل</option>
            <option value="approved">موافق عليه</option>
            <option value="pending">معلق</option>
            <option value="rejected">مرفوض</option>
          </Select>
        </FilterField>
        <FilterField label="الكورس">
          <Select value={courseId} onChange={e=>setCourseId(e.target.value)}>
            <option value="">كل الكورسات</option>
            {courses.map(c=><option key={c.id} value={c.id}>{c.name_ar}</option>)}
          </Select>
        </FilterField>
        <FilterField label="بحث">
          <Input placeholder="كورس أو كوبون..." value={search} onChange={e=>setSearch(e.target.value)} />
        </FilterField>
      </div>

      {/* إحصاءات */}
      <div style={{display:'flex',gap:'12px',flexWrap:'wrap'}}>
        <StatCard label="إجمالي الإيرادات" value={`${fmt(totalRev)} جنيه`} color={C.green} sub={`${active.length} عملية مكتملة`} />
        <StatCard label="إجمالي العمليات"  value={filtered.length} sub={`${filtered.filter(p=>p.status==='pending').length} معلقة`} />
        <StatCard label="متوسط الفاتورة"   value={active.length?`${fmt(Math.round(totalRev/active.length))} جنيه`:'—'} color={C.cyan} />
        <StatCard label="كارت" value={`${fmt(active.filter(p=>p.method==='card').reduce((s,p)=>s+(p.amount||0),0))} جنيه`} color={C.primary} sub={`${active.filter(p=>p.method==='card').length} عملية`} />
        <StatCard label="فودافون + تحويل" value={`${fmt(active.filter(p=>p.method!=='card').reduce((s,p)=>s+(p.amount||0),0))} جنيه`} color={C.amber} sub={`${active.filter(p=>p.method!=='card').length} عملية`} />
      </div>

      <BarChart data={monthly} label="الإيرادات الشهرية (آخر 6 شهور)" color={C.primary} />

      <Table cols={cols} rows={filtered} emptyMsg="لا توجد دفعات بهذه الفلاتر" />
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// ② تقرير نشاط المستخدمين
// ══════════════════════════════════════════════════════════
function UserActivityReport({ customers }) {
  const [logs,     setLogs]     = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [from,     setFrom]     = useState(monthAgo());
  const [to,       setTo]       = useState(today());
  const [action,   setAction]   = useState('');
  const [custId,   setCustId]   = useState('');
  const [device,   setDevice]   = useState('');
  const [search,   setSearch]   = useState('');

  useEffect(()=>{
    fetchLogs('user').then(rows=>{ setLogs(rows); setLoading(false); });
  },[]);

  const filtered = logs.filter(l=>{
    const d = new Date(l.created_at);
    if (from && d < new Date(from)) return false;
    if (to   && d > new Date(to+'T23:59:59')) return false;
    if (action && l.action !== action) return false;
    if (custId && String(l.customer_id) !== custId) return false;
    if (device === 'mobile' && !(l.user_agent||'').includes('Mobile')) return false;
    if (device === 'desktop' && (l.user_agent||'').includes('Mobile')) return false;
    if (search) {
      const s=search.toLowerCase();
      if (!(l.customer_name||'').toLowerCase().includes(s) &&
          !(l.customer_email||'').toLowerCase().includes(s) &&
          !(l.entity_name||'').toLowerCase().includes(s)) return false;
    }
    return true;
  });

  // نشاط كل يوم
  const daily = Array.from({length:7},(_,i)=>{
    const d=new Date(); d.setDate(d.getDate()-(6-i));
    const ds=d.toDateString();
    return { l:d.toLocaleDateString('ar-EG',{weekday:'short'}), v:logs.filter(l=>new Date(l.created_at).toDateString()===ds).length };
  });

  const uniqueUsers = [...new Set(filtered.map(l=>l.customer_id).filter(Boolean))].length;

  const cols = [
    { key:'time',   label:'الوقت',     nowrap:true, render:r=>fmtDate(r.created_at) },
    { key:'name',   label:'المستخدم',  bold:true,   render:r=>r.customer_name||'زائر' },
    { key:'email',  label:'الإيميل',   color:C.primary, render:r=>r.customer_email||'—' },
    { key:'action', label:'الإجراء',   render:r=>{
      const map={'login':'🔑 دخول','logout':'🚪 خروج','register':'📝 تسجيل','view_course':'👁 كورس','view_lesson':'▶ حلقة','payment_start':'💳 بدء دفع','payment_complete':'✅ دفع مكتمل'};
      return map[r.action]||r.action;
    }},
    { key:'entity', label:'التفاصيل',  render:r=>r.entity_name||'—' },
    { key:'device', label:'الجهاز',    nowrap:true, render:r=>(r.user_agent||'').includes('Mobile')?'📱 موبايل':'💻 كمبيوتر' },
  ];

  return (
    <div style={{display:'flex',flexDirection:'column',gap:'16px'}}>
      <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:'12px',padding:'16px',display:'flex',flexWrap:'wrap',gap:'12px',alignItems:'flex-end'}}>
        <FilterField label="من تاريخ"><Input type="date" value={from} onChange={e=>setFrom(e.target.value)} /></FilterField>
        <FilterField label="إلى تاريخ"><Input type="date" value={to}   onChange={e=>setTo(e.target.value)} /></FilterField>
        <FilterField label="نوع الإجراء">
          <Select value={action} onChange={e=>setAction(e.target.value)}>
            <option value="">كل الإجراءات</option>
            <option value="login">دخول</option>
            <option value="logout">خروج</option>
            <option value="register">تسجيل جديد</option>
            <option value="view_course">مشاهدة كورس</option>
            <option value="view_lesson">مشاهدة حلقة</option>
            <option value="payment_start">بدء دفع</option>
            <option value="payment_complete">إتمام دفع</option>
          </Select>
        </FilterField>
        <FilterField label="المستخدم">
          <Select value={custId} onChange={e=>setCustId(e.target.value)}>
            <option value="">كل المستخدمين</option>
            {customers.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
          </Select>
        </FilterField>
        <FilterField label="الجهاز">
          <Select value={device} onChange={e=>setDevice(e.target.value)}>
            <option value="">الكل</option>
            <option value="mobile">موبايل</option>
            <option value="desktop">كمبيوتر</option>
          </Select>
        </FilterField>
        <FilterField label="بحث">
          <Input placeholder="اسم أو إيميل..." value={search} onChange={e=>setSearch(e.target.value)} />
        </FilterField>
      </div>

      <div style={{display:'flex',gap:'12px',flexWrap:'wrap'}}>
        <StatCard label="إجمالي الإجراءات" value={filtered.length} color={C.cyan} />
        <StatCard label="مستخدمين فريدين"  value={uniqueUsers} color={C.primary} />
        <StatCard label="عمليات دخول"      value={filtered.filter(l=>l.action==='login').length} color={C.green} />
        <StatCard label="تسجيلات جديدة"    value={filtered.filter(l=>l.action==='register').length} color={C.amber} />
        <StatCard label="دفعات مكتملة"     value={filtered.filter(l=>l.action==='payment_complete').length} color={C.successT} />
      </div>

      <BarChart data={daily} label="النشاط اليومي (آخر 7 أيام)" color={C.cyan} />

      {loading ? <p style={{textAlign:'center',color:C.muted,padding:'32px'}}>جاري التحميل...</p>
               : <Table cols={cols} rows={filtered} emptyMsg="لا يوجد نشاط بهذه الفلاتر — تأكد من تشغيل reports-migration.sql" />}
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// ③ تقرير الموظفين
// ══════════════════════════════════════════════════════════
function EmployeeReport({ employees }) {
  const [sessions, setSessions] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [from,     setFrom]     = useState(monthAgo());
  const [to,       setTo]       = useState(today());
  const [empId,    setEmpId]    = useState('');
  const [action,   setAction]   = useState('');
  const [view,     setView]     = useState('sessions'); // sessions | summary

  useEffect(()=>{
    fetchLogs('employee').then(rows=>{ setSessions(rows); setLoading(false); });
  },[]);

  const filtered = sessions.filter(s=>{
    const d=new Date(s.created_at||s.session_start);
    if (from && d < new Date(from)) return false;
    if (to   && d > new Date(to+'T23:59:59')) return false;
    if (empId  && String(s.employee_id) !== empId) return false;
    if (action && s.action !== action) return false;
    return true;
  });

  // ملخص لكل موظف
  const empSummary = employees.map(emp=>{
    const empS = sessions.filter(s=>s.employee_id===emp.id);
    const loginS = empS.filter(s=>s.action==='login');
    const lastLogin = loginS[0];
    const totalMins = loginS.filter(s=>s.session_end).reduce((acc,s)=>{
      return acc + (new Date(s.session_end)-new Date(s.session_start||s.created_at))/60000;
    },0);
    return {
      name:    emp.name_ar,
      role:    emp.role?.label_ar||'—',
      logins:  loginS.length,
      actions: empS.filter(s=>!['login','logout'].includes(s.action)).length,
      avgMins: loginS.filter(s=>s.session_end).length ? Math.round(totalMins/loginS.filter(s=>s.session_end).length) : 0,
      last:    lastLogin ? fmtDate(lastLogin.session_start||lastLogin.created_at) : 'لم يدخل',
    };
  });

  const actionLabel = a=>{
    const m={'login':'🔑 دخول','logout':'🚪 خروج','approve_payment':'✅ قبول دفع','reject_payment':'❌ رفض دفع','add_course':'➕ كورس','edit_course':'✏️ كورس','delete_course':'🗑 كورس','add_lesson':'➕ حلقة','edit_lesson':'✏️ حلقة','add_employee':'👤 موظف','edit_employee':'✏️ موظف','add_coupon':'🎟 كوبون','view_reports':'📊 تقارير','edit_settings':'⚙️ إعدادات'};
    return m[a]||a;
  };

  const sessionCols = [
    { key:'time',   label:'الوقت',       nowrap:true, render:r=>fmtDate(r.session_start||r.created_at) },
    { key:'end',    label:'الانتهاء',    nowrap:true, render:r=>r.session_end?fmtDate(r.session_end):'—' },
    { key:'dur',    label:'المدة',       nowrap:true, render:r=>r.session_end?`${Math.round((new Date(r.session_end)-new Date(r.session_start||r.created_at))/60000)} د`:'—' },
    { key:'name',   label:'الموظف',      bold:true,   render:r=>r.employee_name||'—' },
    { key:'role',   label:'الوظيفة',     render:r=>r.employee_role||'—' },
    { key:'action', label:'الإجراء',     render:r=>actionLabel(r.action) },
    { key:'entity', label:'الكيان',      render:r=>r.entity_name||'—' },
  ];

  const summaryCols = [
    { key:'name',    label:'الموظف',          bold:true },
    { key:'role',    label:'الوظيفة' },
    { key:'logins',  label:'مرات الدخول',     color:C.primary },
    { key:'actions', label:'إجراءات',          color:C.amber },
    { key:'avgMins', label:'متوسط الجلسة',    render:r=>`${r.avgMins} دقيقة` },
    { key:'last',    label:'آخر دخول',         nowrap:true },
  ];

  return (
    <div style={{display:'flex',flexDirection:'column',gap:'16px'}}>
      <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:'12px',padding:'16px',display:'flex',flexWrap:'wrap',gap:'12px',alignItems:'flex-end'}}>
        <FilterField label="من تاريخ"><Input type="date" value={from} onChange={e=>setFrom(e.target.value)} /></FilterField>
        <FilterField label="إلى تاريخ"><Input type="date" value={to}   onChange={e=>setTo(e.target.value)} /></FilterField>
        <FilterField label="الموظف">
          <Select value={empId} onChange={e=>setEmpId(e.target.value)}>
            <option value="">كل الموظفين</option>
            {employees.map(e=><option key={e.id} value={e.id}>{e.name_ar}</option>)}
          </Select>
        </FilterField>
        <FilterField label="نوع الإجراء">
          <Select value={action} onChange={e=>setAction(e.target.value)}>
            <option value="">كل الإجراءات</option>
            <option value="login">دخول</option>
            <option value="logout">خروج</option>
            <option value="approve_payment">قبول دفع</option>
            <option value="reject_payment">رفض دفع</option>
            <option value="add_course">إضافة كورس</option>
            <option value="edit_course">تعديل كورس</option>
            <option value="delete_course">حذف كورس</option>
            <option value="add_lesson">إضافة حلقة</option>
            <option value="view_reports">فتح تقارير</option>
            <option value="edit_settings">تعديل إعدادات</option>
          </Select>
        </FilterField>
        <FilterField label="عرض">
          <Select value={view} onChange={e=>setView(e.target.value)}>
            <option value="sessions">السجل التفصيلي</option>
            <option value="summary">ملخص لكل موظف</option>
          </Select>
        </FilterField>
      </div>

      <div style={{display:'flex',gap:'12px',flexWrap:'wrap'}}>
        <StatCard label="إجمالي الجلسات"   value={filtered.filter(s=>s.action==='login').length} color={C.primary} />
        <StatCard label="إجمالي الإجراءات" value={filtered.filter(s=>!['login','logout'].includes(s.action)).length} color={C.amber} />
        <StatCard label="موافقات دفع"      value={sessions.filter(s=>s.action==='approve_payment').length} color={C.green} />
        <StatCard label="رفض دفع"          value={sessions.filter(s=>s.action==='reject_payment').length} color={C.red} />
      </div>

      {loading ? <p style={{textAlign:'center',color:C.muted,padding:'32px'}}>جاري التحميل...</p>
               : view==='summary'
               ? <Table cols={summaryCols} rows={empSummary} />
               : <Table cols={sessionCols} rows={filtered} emptyMsg="لا توجد جلسات — تأكد من تشغيل reports-migration.sql" />}
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// ④ تقرير الكورسات
// ══════════════════════════════════════════════════════════
function CoursesReport({ courses, lessons, enrollments, payments }) {
  const [search, setSearch] = useState('');
  const [sortBy, setSortBy] = useState('sales');

  const data = courses.map(c=>{
    const active = payments.filter(p=>p.course_id===c.id&&(p.status==='active'||p.status==='approved'));
    return {
      name:     c.name_ar,
      price:    `${fmt(c.price)} جنيه`,
      lessons:  lessons.filter(l=>l.course_id===c.id).length,
      enrolls:  enrollments.filter(e=>e.course_id===c.id&&e.status==='active').length,
      revenue:  active.reduce((s,p)=>s+(p.amount||0),0),
      avg:      active.length?Math.round(active.reduce((s,p)=>s+(p.amount||0),0)/active.length):0,
      _raw: c,
    };
  }).filter(r=>!search||r.name.includes(search))
    .sort((a,b)=>sortBy==='sales'?b.enrolls-a.enrolls:sortBy==='revenue'?b.revenue-a.revenue:b.lessons-a.lessons);

  const cols = [
    { key:'rank',    label:'#',           render:(_,i)=>i+1, nowrap:true },
    { key:'name',    label:'الكورس',      bold:true },
    { key:'price',   label:'السعر' },
    { key:'lessons', label:'الحلقات',     color:C.cyan },
    { key:'enrolls', label:'الاشتراكات',  color:C.primary },
    { key:'revenue', label:'الإيرادات',   bold:true, color:C.green, render:r=>`${fmt(r.revenue)} جنيه` },
    { key:'avg',     label:'متوسط الفاتورة', render:r=>r.avg?`${fmt(r.avg)} جنيه`:'—' },
  ];

  return (
    <div style={{display:'flex',flexDirection:'column',gap:'16px'}}>
      <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:'12px',padding:'16px',display:'flex',flexWrap:'wrap',gap:'12px',alignItems:'flex-end'}}>
        <FilterField label="بحث"><Input placeholder="اسم الكورس..." value={search} onChange={e=>setSearch(e.target.value)} /></FilterField>
        <FilterField label="ترتيب حسب">
          <Select value={sortBy} onChange={e=>setSortBy(e.target.value)}>
            <option value="sales">الأعلى مبيعاً</option>
            <option value="revenue">الأعلى إيراداً</option>
            <option value="lessons">الأكثر حلقات</option>
          </Select>
        </FilterField>
      </div>

      <div style={{display:'flex',gap:'12px',flexWrap:'wrap'}}>
        <StatCard label="إجمالي الكورسات"    value={courses.length} color={C.primary} />
        <StatCard label="إجمالي الحلقات"     value={lessons.length} color={C.cyan} />
        <StatCard label="اشتراكات فعّالة"    value={enrollments.filter(e=>e.status==='active').length} color={C.green} />
        <StatCard label="أكتر كورس مبيعاً"   value={data[0]?.name||'—'} color={C.amber} />
      </div>

      <Table cols={cols} rows={data} />
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// ⑤ تقرير الكوبونات
// ══════════════════════════════════════════════════════════
function CouponsReport({ courses }) {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status,  setStatus]  = useState('');
  const [type,    setType]    = useState('');
  const [search,  setSearch]  = useState('');

  useEffect(()=>{
    supabase.from('coupons').select('*, courses(name_ar)').order('created_at',{ascending:false})
      .then(({data})=>{ if(data) setCoupons(data); setLoading(false); });
  },[]);

  const filtered = coupons.filter(c=>{
    if (status==='active'   && !c.is_active) return false;
    if (status==='inactive' && c.is_active)  return false;
    if (status==='used'     && !c.used_count) return false;
    if (type && c.type!==type) return false;
    if (search && !c.code.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const cols = [
    { key:'code',    label:'كود الخصم', bold:true, render:r=>(
      <span style={{background:'#eef2ff',color:C.primary,padding:'3px 10px',borderRadius:'6px',fontFamily:'monospace',fontWeight:'600',letterSpacing:'1px'}}>
        {r.code}
      </span>
    )},
    { key:'type',    label:'النوع',     render:r=>r.type==='percent'?`📊 ${r.value}%`:`💰 ${fmt(r.value)} جنيه` },
    { key:'scope',   label:'ينطبق على', render:r=>r.courses?.name_ar||'🌍 كل الكورسات' },
    { key:'uses',    label:'الاستخدام', render:r=>(
      <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
        <div style={{width:'60px',height:'5px',background:C.border,borderRadius:'3px'}}>
          <div style={{height:'100%',borderRadius:'3px',background:C.primary,width:`${r.max_uses?Math.min((r.used_count/r.max_uses)*100,100):r.used_count>0?50:0}%`}} />
        </div>
        <span style={{fontSize:'12px',fontWeight:'600',color:C.primary}}>{r.used_count||0}</span>
        <span style={{fontSize:'11px',color:C.muted}}>/ {r.max_uses||'∞'}</span>
      </div>
    )},
    { key:'expires', label:'الانتهاء',  nowrap:true, render:r=>r.expires_at?fmtDateOnly(r.expires_at):'بدون انتهاء' },
    { key:'status',  label:'الحالة',    render:r=>(
      <span style={{padding:'2px 8px',borderRadius:'6px',fontSize:'11px',fontWeight:'600',background:r.is_active?C.success:C.danger,color:r.is_active?C.successT:C.dangerT}}>
        {r.is_active?'مفعّل':'موقوف'}
      </span>
    )},
  ];

  return (
    <div style={{display:'flex',flexDirection:'column',gap:'16px'}}>
      <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:'12px',padding:'16px',display:'flex',flexWrap:'wrap',gap:'12px',alignItems:'flex-end'}}>
        <FilterField label="الحالة">
          <Select value={status} onChange={e=>setStatus(e.target.value)}>
            <option value="">الكل</option>
            <option value="active">مفعّل</option>
            <option value="inactive">موقوف</option>
            <option value="used">مستخدم</option>
          </Select>
        </FilterField>
        <FilterField label="النوع">
          <Select value={type} onChange={e=>setType(e.target.value)}>
            <option value="">الكل</option>
            <option value="percent">نسبة %</option>
            <option value="fixed">مبلغ ثابت</option>
          </Select>
        </FilterField>
        <FilterField label="بحث بالكود">
          <Input placeholder="GAWHARA..." value={search} onChange={e=>setSearch(e.target.value)} />
        </FilterField>
      </div>

      <div style={{display:'flex',gap:'12px',flexWrap:'wrap'}}>
        <StatCard label="إجمالي الكوبونات"  value={coupons.length} color={C.primary} />
        <StatCard label="مفعّل"              value={coupons.filter(c=>c.is_active).length} color={C.green} />
        <StatCard label="إجمالي الاستخدام"   value={coupons.reduce((s,c)=>s+(c.used_count||0),0)} color={C.amber} />
        <StatCard label="موقوف"              value={coupons.filter(c=>!c.is_active).length} color={C.red} />
      </div>

      {loading ? <p style={{textAlign:'center',color:C.muted,padding:'32px'}}>جاري التحميل...</p>
               : <Table cols={cols} rows={filtered} />}
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// الـ HUB الرئيسي
// ══════════════════════════════════════════════════════════
const REPORTS = [
  { id:'revenue',   icon:'💰', label:'الإيرادات' },
  { id:'users',     icon:'👥', label:'نشاط المستخدمين' },
  { id:'employees', icon:'👨‍💼', label:'نشاط الموظفين' },
  { id:'courses',   icon:'📚', label:'الكورسات' },
  { id:'coupons',   icon:'🎟️', label:'الكوبونات' },
];

export default function Reports({ lang, isRTL, payments, customers, courses, lessons, enrollments, employees, onBack, onOpenBuilder }) {
  const [active, setActive] = useState('revenue');
  const printRef = useRef();

  const handlePrint = () => {
    const w = window.open('','_blank');
    w.document.write(`<html><head><title>تقرير — الجوهرة Academy</title>
      <style>body{font-family:Arial,sans-serif;direction:rtl;font-size:12px;}table{width:100%;border-collapse:collapse;}th,td{border:1px solid #ddd;padding:6px;text-align:right;}th{background:#5a67d8;color:white;}tr:nth-child(even){background:#f9f9f9;}.no-print{display:none!important;}</style></head><body>`);
    w.document.write(printRef.current.innerHTML);
    w.document.write('</body></html>');
    w.document.close();
    w.print();
  };

  const current = REPORTS.find(r=>r.id===active);

  return (
    <div style={{fontFamily:'Cairo,Arial,sans-serif',direction:'rtl'}}>

      {/* هيدر */}
      <div style={{background:C.white,borderRadius:'16px',padding:'20px 24px',marginBottom:'16px',border:`1px solid ${C.border}`,display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:'12px'}}>
        <div>
          <h2 style={{margin:0,fontSize:'20px',fontWeight:'bold',color:C.primary}}>📊 مركز التقارير</h2>
          <p style={{margin:'3px 0 0',color:C.muted,fontSize:'12px'}}>{new Date().toLocaleDateString('ar-EG',{weekday:'long',year:'numeric',month:'long',day:'numeric'})}</p>
        </div>
        <div style={{display:'flex',gap:'8px'}}>
          {onOpenBuilder && (
            <button onClick={onOpenBuilder}
              style={{padding:'8px 16px',background:'linear-gradient(135deg,#5a67d8,#764ba2)',color:C.white,border:'none',borderRadius:'8px',fontSize:'13px',fontWeight:'bold',cursor:'pointer',display:'flex',alignItems:'center',gap:'6px'}}>
              🔧 صانع التقارير
            </button>
          )}
          <button onClick={handlePrint}
            style={{padding:'8px 16px',background:'linear-gradient(135deg,#5a67d8,#764ba2)',color:C.white,border:'none',borderRadius:'8px',fontSize:'13px',fontWeight:'bold',cursor:'pointer',display:'flex',alignItems:'center',gap:'6px'}}>
            🖨️ طباعة
          </button>
          <button onClick={onBack}
            style={{padding:'8px 14px',background:C.bg,border:`1px solid ${C.border}`,borderRadius:'8px',fontSize:'13px',fontWeight:'bold',cursor:'pointer',color:C.text}}>
            ← رجوع
          </button>
        </div>
      </div>

      {/* تابس */}
      <div style={{display:'flex',gap:'8px',marginBottom:'16px',flexWrap:'wrap'}}>
        {REPORTS.map(r=>(
          <button key={r.id} onClick={()=>setActive(r.id)}
            style={{padding:'10px 20px',border:`2px solid ${active===r.id?C.primary:C.border}`,borderRadius:'10px',background:active===r.id?'#eef2ff':C.white,color:active===r.id?C.primary:C.text,cursor:'pointer',fontSize:'13px',fontWeight:active===r.id?'bold':'400',transition:'all 0.15s',display:'flex',alignItems:'center',gap:'6px'}}>
            <span style={{fontSize:'16px'}}>{r.icon}</span> {r.label}
          </button>
        ))}
      </div>

      {/* عنوان التقرير الحالي */}
      <div style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:'12px 12px 0 0',padding:'14px 20px',borderBottom:'none',display:'flex',alignItems:'center',gap:'10px'}}>
        <span style={{fontSize:'20px'}}>{current?.icon}</span>
        <h3 style={{margin:0,fontSize:'16px',fontWeight:'bold',color:C.text}}>تقرير {current?.label}</h3>
      </div>

      {/* محتوى التقرير */}
      <div ref={printRef} style={{background:C.white,border:`1px solid ${C.border}`,borderRadius:'0 0 12px 12px',padding:'20px'}}>
        {active==='revenue'   && <RevenueReport   payments={payments} courses={courses} />}
        {active==='users'     && <UserActivityReport customers={customers} />}
        {active==='employees' && <EmployeeReport employees={employees} />}
        {active==='courses'   && <CoursesReport courses={courses} lessons={lessons} enrollments={enrollments} payments={payments} />}
        {active==='coupons'   && <CouponsReport courses={courses} />}
      </div>
    </div>
  );
}
